export interface SuiEncodeConfig {
    transaction: string;
}
